import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../config';
import HomeButton from '../components/HomeButton';
import Carousel from '../components/Carousel';

const Contact = () => {
    const [authStatus, setAuthStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAdminPanel, setShowAdminPanel] = useState(false);

    // Controlla lo stato di autenticazione
    useEffect(() => {
        checkAuthStatus();
        
        // Controlla se ritorna da autenticazione
        const params = new URLSearchParams(window.location.search);
        if (params.get('auth') === 'success') {
            setShowAdminPanel(true);
            // Pulisci URL
            window.history.replaceState({}, '', '/contact');
        }
    }, []);

    const checkAuthStatus = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/google/status`);
            const data = await response.json();
            
            if (data.success && data.authenticated) {
                setAuthStatus({
                    authenticated: true,
                    accounts: data.accounts
                });
            } else {
                setAuthStatus({
                    authenticated: false,
                    accounts: []
                });
            }
        } catch (error) {
            console.error('Errore controllo autenticazione:', error);
            setAuthStatus({
                authenticated: false,
                accounts: []
            });
        } finally {
            setLoading(false);
        }
    };

    const signInWithGoogle = () => {
        // Redirect al backend per Google OAuth
        window.location.href = `${API_BASE_URL}/api/google/oauth`;
    };

    const disconnectGoogle = async (email) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/google/disconnect`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (data.success) {
                alert('Account disconnesso!');
                checkAuthStatus(); // Ricarica lo stato
            }
        } catch (error) {
            console.error('Errore disconnessione:', error);
            alert('Errore durante la disconnessione');
        }
    };

    return (
        <div style={{
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <HomeButton />
            <div className="home-hero__bg" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0
            }}>
                <Carousel />
            </div>
            
            {/* Sezione Recapiti - Centrata */}
            <div style={{ 
                position: 'relative', 
                zIndex: 2, 
                padding: '32px',
                maxWidth: '600px',
                width: '90%',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '8px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
            }}>
                <h2 style={{ 
                    marginBottom: '25px',
                    color: '#333',
                    fontSize: '2rem',
                    textAlign: 'center'
                }}>
                    📞 Contattaci
                </h2>

                <div style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    marginBottom: '30px'
                }}>
                    <div style={{ 
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        borderLeft: '4px solid #d4af37'
                    }}>
                        <h3 style={{ 
                            margin: '0 0 10px 0',
                            color: '#555',
                            fontSize: '1.1rem'
                        }}>
                            📱 Telefono
                        </h3>
                        <a href="tel:3517174224" style={{ 
                            fontSize: '1.3rem',
                            color: '#d4af37',
                            textDecoration: 'none',
                            fontWeight: 'bold'
                        }}>
                            351 717 4224
                        </a>
                    </div>

                    <div style={{ 
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        borderLeft: '4px solid #d4af37'
                    }}>
                        <h3 style={{ 
                            margin: '0 0 10px 0',
                            color: '#555',
                            fontSize: '1.1rem'
                        }}>
                            📍 Indirizzo
                        </h3>
                        <p style={{ 
                            margin: '0',
                            fontSize: '1.1rem',
                            color: '#333',
                            lineHeight: '1.6'
                        }}>
                            <strong>Ristopub Ultima Spiaggia</strong><br />
                            Via Fondaco Nesci, 1<br />
                            89038 Palizzi Marina (RC)
                        </p>
                        <a 
                            href="https://maps.google.com/?q=Via+Fondaco+Nesci+1,+89038+Palizzi+Marina+RC"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'inline-block',
                                marginTop: '10px',
                                padding: '8px 16px',
                                backgroundColor: '#d4af37',
                                color: 'white',
                                textDecoration: 'none',
                                borderRadius: '4px',
                                fontSize: '0.9rem'
                            }}
                        >
                            🗺️ Apri in Google Maps
                        </a>
                    </div>
                </div>

                {/* Pulsante Admin */}
                <button
                    onClick={() => {
                        console.log('Click Admin - authStatus:', authStatus, 'loading:', loading);
                        if (loading) {
                            // Se ancora in caricamento, vai direttamente a OAuth
                            signInWithGoogle();
                        } else if (authStatus?.authenticated) {
                            setShowAdminPanel(true);
                        } else {
                            signInWithGoogle();
                        }
                    }}
                    style={{
                        width: '100%',
                        padding: '12px 20px',
                        backgroundColor: '#333',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#555'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#333'}
                >
                    🔐 Admin
                </button>
            </div>

            {/* Pannello Admin - Modale in sovraimpressione */}
            {showAdminPanel && (
                <>
                    {/* Overlay scuro */}
                    <div 
                        onClick={() => setShowAdminPanel(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            zIndex: 999,
                            backdropFilter: 'blur(5px)',
                            animation: 'fadeIn 0.3s ease'
                        }}
                    />
                    
                    {/* Modale Admin */}
                    <div style={{ 
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1000,
                        padding: '32px',
                        maxWidth: '600px',
                        width: '90%',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        borderRadius: '12px',
                        border: '3px solid #d4af37',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
                        animation: 'slideIn 0.3s ease'
                    }}>
                        {/* Pulsante chiudi */}
                        <button
                            onClick={() => setShowAdminPanel(false)}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                width: '35px',
                                height: '35px',
                                border: 'none',
                                borderRadius: '50%',
                                backgroundColor: '#ff4444',
                                color: 'white',
                                fontSize: '20px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#cc0000'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#ff4444'}
                        >
                            ×
                        </button>

                        <h2 style={{ marginBottom: '20px', color: '#333', marginTop: '0' }}>
                            🔗 Collega Google Calendar
                        </h2>

                        {loading ? (
                            <p style={{ color: '#333' }}>Caricamento...</p>
                        ) : authStatus?.authenticated ? (
                            <div>
                                <p style={{ marginBottom: '15px', color: '#333', fontSize: '1.1rem' }}>
                                    ✅ Sei autenticato come amministratore
                                </p>
                                
                                <button 
                                    onClick={() => {
                                        if (authStatus.accounts.length > 0) {
                                            disconnectGoogle(authStatus.accounts[0]);
                                        }
                                    }}
                                    style={{
                                        padding: '12px 24px',
                                        backgroundColor: '#ff4444',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: 'bold'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#cc0000'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#ff4444'}
                                >
                                    🔓 Disconnetti
                                </button>
                            </div>
                        ) : (
                            <div>
                                <p style={{ marginBottom: '15px', color: '#333' }}>
                                    Per gestire le prenotazioni tramite Google Calendar, 
                                    devi prima collegare il tuo account Google.
                                </p>
                                <button 
                                    onClick={signInWithGoogle}
                                    style={{
                                        padding: '12px 24px',
                                        backgroundColor: '#4285f4',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18">
                                        <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                                        <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
                                        <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/>
                                        <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/>
                                    </svg>
                                    Accedi con Google
                                </button>
                            </div>
                        )}

                        <div style={{ 
                            marginTop: '30px', 
                            padding: '15px',
                            backgroundColor: '#e8f4f8',
                            borderRadius: '4px',
                            fontSize: '14px'
                        }}>
                            <strong>ℹ️ Informazioni:</strong>
                            <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                                <li>Il collegamento è sicuro e gestito tramite Google OAuth</li>
                                <li>Le prenotazioni verranno sincronizzate automaticamente</li>
                                <li>Puoi disconnettere l'account in qualsiasi momento</li>
                            </ul>
                        </div>
                    </div>

                    <style>{`
                        @keyframes fadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                        }
                        @keyframes slideIn {
                            from { 
                                opacity: 0;
                                transform: translate(-50%, -60%);
                            }
                            to { 
                                opacity: 1;
                                transform: translate(-50%, -50%);
                            }
                        }
                    `}</style>
                </>
            )}
        </div>
    );
};

export default Contact;